import type { BoxProps } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import range from 'lodash/range';
import type { FunctionComponent } from 'react';
import styled from 'styled-components';

import { StarIcon } from './StarIcon';

const MAX_RATING = 5;

interface StarRatingProps extends BoxProps {
  maxRating?: number;
  rating?: number;
  primaryColor?: string;
  className?: string;
}

/**
 * Component to render star rating
 */
const UnstyledStarRating: FunctionComponent<StarRatingProps> = ({
  maxRating = MAX_RATING,
  rating = MAX_RATING,
  primaryColor = '#ff3975',
  className,
  ...boxProps
}): JSX.Element => {
  const roundRating = Math.floor(rating);

  return (
    <Box className={className} {...boxProps}>
      {range(0, maxRating).map((i) => (
        <Box key={i} className="starContainer" bgcolor={i < roundRating ? primaryColor : '#d9e0e9'}>
          <StarIcon />
        </Box>
      ))}
    </Box>
  );
};

export const StarRating = styled(UnstyledStarRating)`
  display: flex;
  align-items: center;

  .starContainer {
    width: 1rem;
    height: 1rem;
    border-radius: 0.125rem;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.125rem 0.25rem 0.25rem 0.125rem;
    margin-right: 0.125rem;
    &:last-child {
      margin-right: 0;
    }
  }
`;
